import { render, staticRenderFns } from "./ClaimTransactionPropertyGroup.vue?vue&type=template&id=3e878f80&"
import script from "./ClaimTransactionPropertyGroup.vue?vue&type=script&lang=js&"
export * from "./ClaimTransactionPropertyGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e878f80')) {
      api.createRecord('3e878f80', component.options)
    } else {
      api.reload('3e878f80', component.options)
    }
    module.hot.accept("./ClaimTransactionPropertyGroup.vue?vue&type=template&id=3e878f80&", function () {
      api.rerender('3e878f80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Page/EssAdmin/Claim/ClaimTransactionPropertyGroup/ClaimTransactionPropertyGroup.vue"
export default component.exports